import * as React from "react"

type ValueTextProps = {
  children: string | number
  prefix?: string
  unit: string
}

export const ValueText: React.FC<ValueTextProps> = ({ prefix, unit, children }) => {
  return (
    <>
      <span className="text-lg">
        {prefix || ''}
      </span>{children}<span className="text-lg">
        {unit}
      </span>
    </>
  )
}